/**
 * Toggle `aria-current` for items in the table of contents (TOC) depending on scroll state.
 */
(() => {
    const items = document.querySelectorAll('.js-toc-item');

    if (!items.length) {
        return;
    }

    const header = document.querySelector('.site-header');
    const adminBar = document.querySelector('#wpadminbar');
    const headings = [...document.querySelectorAll('h2[id]')].filter(
        (h) => !h.closest('.js-toc-content')
    );

    function getTopOffset() {
        return header?.offsetHeight ?? 0 + adminBar?.offsetHeight ?? 0;
    }

    function setCurrent() {
        const topOffset = getTopOffset();
        const viewportBottom = window.innerHeight;

        const visible = headings.filter((h) => {
            const top = h.getBoundingClientRect().top;
            return top >= topOffset && top <= viewportBottom;
        });

        const current =
            visible[0] ??
            [...headings]
                .reverse()
                .find((h) => h.getBoundingClientRect().top < topOffset) ??
            null;

        items.forEach((item) => {
            item.querySelector('a[aria-current]')?.removeAttribute(
                'aria-current'
            );
        });

        if (current) {
            items.forEach((item) => {
                item.querySelector(`a[href="#${current.id}"]`)?.setAttribute(
                    'aria-current',
                    'true'
                );
            });
        }
    }

    window.addEventListener('scroll-throttle', setCurrent);
    setCurrent();
})();
